import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'

interface C003AuthMfaCodeCreateProps {
  execAuthMfaCodeCreate: (loginId: string) => Promise<Result>
  loading: loadStatus
}
// C003 2段階認証用コード作成API呼出
export const useC003AuthMfaCodeCreate = (): C003AuthMfaCodeCreateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const execAuthMfaCodeCreate = async (loginId: string) => {
    try {
      setLoading(loadStatus.LOADED)
      // ヘッダ作成
      const header = axiosDefaultHeader
      const body = { loginId: loginId }
      const response = await axios.post(
        `${baseUrl}${stage}${apiUrl.authPath}/mfa/code-create`,
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )
      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }
  return { execAuthMfaCodeCreate, loading }
}
